import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_ADMIN_DASHBOARD_PROGRAMS_KEY } from "../../../api/queryKeys";
import { QueryAdminDashboardProgramsResponse } from "../../../types";

// Broken out because this fn is called in a couple place
export const getProgramsData = () =>
  api
    .get<QueryAdminDashboardProgramsResponse>(
      QUERY_ADMIN_DASHBOARD_PROGRAMS_KEY
    )
    .then((res) => res.data);

export default function useGetPrograms() {
  return useQuery([QUERY_ADMIN_DASHBOARD_PROGRAMS_KEY], getProgramsData);
}
